import { render, staticRenderFns } from "./BTableCollectorPublications.vue?vue&type=template&id=29882a29&"
import script from "./BTableCollectorPublications.vue?vue&type=script&lang=js&"
export * from "./BTableCollectorPublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports